module.exports = __webpack_public_path__ + "img/portal.174abc98.png";